import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const feedCardDefaultVariants = {}
const feedCardCompoundVariants = []

const feedCardSlotNames = [
  [
    "card",
    "feed-card__card"
  ],
  [
    "feedPhotoTreatment",
    "feed-card__feedPhotoTreatment"
  ],
  [
    "feedPhotoImage",
    "feed-card__feedPhotoImage"
  ],
  [
    "feedPhotoFallback",
    "feed-card__feedPhotoFallback"
  ],
  [
    "gradient",
    "feed-card__gradient"
  ],
  [
    "contentGrid",
    "feed-card__contentGrid"
  ],
  [
    "contentGridWithIndicators",
    "feed-card__contentGridWithIndicators"
  ],
  [
    "minimapArea",
    "feed-card__minimapArea"
  ],
  [
    "detailsArea",
    "feed-card__detailsArea"
  ],
  [
    "actionsArea",
    "feed-card__actionsArea"
  ],
  [
    "actionWrapper",
    "feed-card__actionWrapper"
  ],
  [
    "propertyName",
    "feed-card__propertyName"
  ],
  [
    "propertyMetaRow",
    "feed-card__propertyMetaRow"
  ],
  [
    "propertyType",
    "feed-card__propertyType"
  ],
  [
    "priceBlock",
    "feed-card__priceBlock"
  ],
  [
    "priceText",
    "feed-card__priceText"
  ],
  [
    "priceUnit",
    "feed-card__priceUnit"
  ],
  [
    "priceMeta",
    "feed-card__priceMeta"
  ],
  [
    "totalPriceTag",
    "feed-card__totalPriceTag"
  ],
  [
    "totalPriceIcon",
    "feed-card__totalPriceIcon"
  ],
  [
    "feesText",
    "feed-card__feesText"
  ],
  [
    "specsText",
    "feed-card__specsText"
  ],
  [
    "actionLabel",
    "feed-card__actionLabel"
  ]
]
const feedCardSlotFns = /* @__PURE__ */ feedCardSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, feedCardDefaultVariants, getSlotCompoundVariant(feedCardCompoundVariants, slotName))])

const feedCardFn = memo((props = {}) => {
  return Object.fromEntries(feedCardSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const feedCardVariantKeys = []
const getVariantProps = (variants) => ({ ...feedCardDefaultVariants, ...compact(variants) })

export const feedCard = /* @__PURE__ */ Object.assign(feedCardFn, {
  __recipe__: false,
  __name__: 'feedCard',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: feedCardVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, feedCardVariantKeys)
  },
  getVariantProps
})